import type { RouteObject } from 'react-router';
import { ModuleRoute } from '@/components/guards';

/** Rotas deste módulo, montadas dentro do layout do painel (caminhos relativos). */
export const fiscalRoutes: RouteObject[] = [
  {
    path: 'notas',
    element: <ModuleRoute module="fiscal" permission="fiscal:read" />,
    children: [
      {
        lazy: async () => ({ Component: (await import('./shared')).FiscalLayout }),
        children: [
          { index: true, lazy: async () => ({ Component: (await import('./documents')).FiscalDocumentsPage }) },
          { path: 'configuracao', lazy: async () => ({ Component: (await import('./settings')).FiscalSettingsPage }) },
          { path: 'perfis', lazy: async () => ({ Component: (await import('./profiles')).TaxProfilesPage }) },
        ],
      },
      { path: ':id', lazy: async () => ({ Component: (await import('./document-detail')).FiscalDocumentPage }) },
    ],
  },
];
